
import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import { CustOrdersData, OrdersData, SecScrnData, TeamEfficiencyData } from '../models/Analytics';
import ScreeningResponse from '../models/ScreeningResponse';

const analyticsReqHandler = {

  getOrdersData: (
    startDate: string,
    endDate: string,
    pickUp: boolean,
    dropOff: boolean,
    hours: number,
  ): Promise<ApiResponse<OrdersData[]>> => {
    let url: string = `analytics/orders?`;
    if (startDate) {
      url = `${url}start_date=${startDate}&`;
    };
    if (endDate) {
      url = `${url}end_date=${endDate}&`;
    };
    if (pickUp) {
      url = `${url}pick_up=${pickUp}&`;
    }
    if (dropOff) {
      url = `${url}drop_off=${dropOff}&`;
    }
    if (hours) {
      url = `${url}hours=${hours}&`;
    }
    return genericApi.get(url);
  },

  getTopCustomers: (
    startDate: string,
    endDate: string,
    pickUp: boolean,
    dropOff: boolean,
    hours: number,
  ): Promise<ApiResponse<CustOrdersData[]>> => {
    let url: string = `analytics/top_customers?`;
    if (startDate) {
      url = `${url}start_date=${startDate}&`;
    };
    if (endDate) {
      url = `${url}end_date=${endDate}&`;
    };
    if (pickUp) {
      url = `${url}pick_up=${pickUp}&`;
    }
    if (dropOff) {
      url = `${url}drop_off=${dropOff}&`;
    }
    if (hours) {
      url = `${url}hours=${hours}&`;
    }
    return genericApi.get(url);
  },

  getTeamEfficiency: (
    startDate: string,
    endDate: string,
    pickUp: boolean,
    dropOff: boolean,
    hours: number,
  ): Promise<ApiResponse<TeamEfficiencyData[]>> => {
    let url: string = `analytics/team_efficiency?`;
    if (startDate) {
      url = `${url}start_date=${startDate}&`;
    };
    if (endDate) {
      url = `${url}end_date=${endDate}&`;
    };
    if (pickUp) {
      url = `${url}pick_up=${pickUp}&`;
    }
    if (dropOff) {
      url = `${url}drop_off=${dropOff}&`;
    }
    if (hours) {
      url = `${url}hours=${hours}&`;
    }
    return genericApi.get(url);
  },

  getScreeningExemptions: (): Promise<ApiResponse<ScreeningResponse[]>> => {
    let url: string = `analytics/screening_exemptions`;
    return genericApi.get(url);
  },

  getScreeningData: (
    startDate: string,
    endDate: string,
    hours: number,
  ): Promise<ApiResponse<SecScrnData[]>> => {
    let url: string = `analytics/awb_screening?`;
    if (startDate) {
      url = `${url}start_date=${startDate}&`;
    };
    if (endDate) {
      url = `${url}end_date=${endDate}&`;
    };
    if (hours) {
      url = `${url}hours=${hours}&`;
    }
    return genericApi.get(url);
  },
}

export default analyticsReqHandler;